import { animate, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { GItem } from '@app/cp/shared/models/GItem';
import { SearchTypeBus } from '@app/cp/shared/models/SearchTypeBus';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { GridComponent, SelectionEvent } from '@progress/kendo-angular-grid';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import * as _ from 'lodash';
import { UseFeatureFlagSet, IFeatureFlagSet } from '../../decorators/featureflags/featureflagset-decorator';
import { SearchTableType } from '../../enums/SearchTableType';
import { SearchTarget } from '../../enums/SearchTarget';
import { BaseMessageInfo } from '../../models/BaseMessageInfo';
import { CommonParam } from '../../models/CommonParam';
import { SearchTypeFieldBus } from '../../models/SearchTypeFieldBus';
import { DQOIService } from '../../services/DQOI.service';
import { SearchService } from '../../services/search.service';
import { CommonFunctions } from '../../static/common-functions';
import { CPSearchInputComponent } from './cp-search-input/cp-search-input.component';

@UseFeatureFlagSet()
@Component({
    selector: 'cp-search',
    templateUrl: './cp-search.component.html',
    styleUrls: ['./cp-search.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('slideInOut', [
            transition(':enter', [
                style({ transform: 'translateX(-100%)' }),
                animate('120ms ease-in', style({ transform: 'translateX(0%)' }))
            ]),
            transition(':leave', [
                animate('120ms ease-in', style({ transform: 'translateX(-100%)' }))
            ])
        ])
    ],
    standalone: false
})
export class CPSearchComponent  implements OnInit {
    compFeatureFlagSet: IFeatureFlagSet = this as any; //Move this inside class
    @ViewChild('grid') protected grid: GridComponent;
    @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective;

    private cpSearchInputPlaceholder: CPSearchInputComponent;
    @ViewChild('cpSearchInputis') set content(content: CPSearchInputComponent) {
        if (content) { // initially setter gets called with undefined
            this.cpSearchInputPlaceholder = content;
        }
    }

    constructor(private svc_srch: SearchService, private globals: GlobalsService,private svc_dqoi: DQOIService) {

        this.advSearchParam = new CommonParam();
        if (this.code == "Inventory") {
            this.showAdvancedSearch = false;
        }
    }
    private _initialParams: CommonParam;
    @Input() set initialParams(param: CommonParam) {
        this._initialParams = param;
    }
    _openSearch: boolean = false;
    @Input() set openSearch(value: boolean) {
        if (value === true) {
            if (CommonFunctions.hasStringValue(this.customInputCode)) {
                switch (this.customInputCode) {
                    case "CALLBACK":
                        //this.showSearchField = false;
                        this.search("", false, false, 0);
                        break;
                    case "ISCONSTRUCTIONINVOICE":
                        this.showSearchField = false;
                        this.search("", false, this.advancedSearchOn);
                        break;
                }
            }
            //ITDEV-437
            if (this.appCode == 'SubPO') {
                this.search("");
            }
        }
        this.advancedSearchOn = this.advancedSearch;
        this._openSearch = value;
    }
    @Input() code: string;
    @Input() readOnly: boolean = false;
    @Input() resetSearch: boolean = true;
    @Input() activeOnly: boolean = true;
    @Input() includeRetired: boolean = false;
    @Input() customInputValue: any;
    @Input() customInputCode: string;
    @Input() appCode: string;
    @Input() isWarranty: any;
    @Input() notAllowAssetPart: boolean = false;
    @Output() selected: EventEmitter<any> = new EventEmitter<any>();
    @Output() searchValueChanged: EventEmitter<any> = new EventEmitter<any>();

    @Output() validationError: EventEmitter<any> = new EventEmitter<any>();
    @Input() searchValue: string = "";
    showSearchField: boolean = true;
    @Input() showAdvancedSearch: boolean = true;
    gridData: any[];
    gridDataOriginal: any[];
    searchType: SearchTypeBus;
    columns: SearchTypeFieldBus[] = [];
    advancedData: SearchTypeFieldBus[];
    advancedDataDate: SearchTypeFieldBus[];
    @Input() set advancedSearch(value: boolean) {
        this.showAdvanced(value);
    }
    showResults: boolean = true;
    returnIfSingular: boolean = false;
    validateMode: boolean = false;
    advancedRefData: GItem[];
    advancedDataValues: Object = new Object();
    @Input() advancedSearchOn: boolean;
    dataLoading: boolean = false;
    public searchFilter: string;
    ngOnInit() {
        this.getSearchTypes();
        if (this.code == "Inventory") {
            this.showAdvancedSearch = false;
        }
    }
    @Input() showInActive: boolean = false;
    isActive: boolean = true;
    openChanged(e: any) {
        this.isActive = e;
    }

    protected getSearchTypes() {
        if (CommonFunctions.hasStringValue(this.code)) {
            this.svc_srch.getSearchTypes(this.code).subscribe(data => {
                this.searchType = _.cloneDeep(data[0]);
                this.setGridLayout();
            });
        }
    }

    onStateChange(e: any) {
    }
    open() {
    }

    reset() {
        if (this.resetSearch) {
            this.searchValue = "";
            this.searchValueChanged.emit(this.searchValue);

            this.gridDataOriginal = [];
            this.gridData = [];
        }
    }
    select(value: any) {
        this.reset();
        this.selected.emit(value);
    }
    selectionChanged(e: SelectionEvent) {
        this.reset();
        this.selected.emit(e.selectedRows[0].dataItem);
    }
    close() {
        this.reset();
        this.selected.emit(null);
    }
    showAdvanced(state: boolean) {
        this.configureAdvanced();
        this.advancedSearchOn = state;
    }
    advSearchParam: CommonParam;
    get advSearchCode(): string {
        let advCode = "CP_" + this.code;
        switch (this.code) {
            case "Dispatch":
                if (this.customInputCode === 'ISCONSTRUCTIONCONTRACT') {
                    advCode = 'CP_Contracts';
                }
                else if (this.customInputCode === 'ISCONSTRUCTION') {
                    advCode = 'CP_Jobs';
                }
                else {
                    advCode = 'CP_Dispatches';
                }
                break;
        }
        return advCode;
    }
    gotSearchTypes: boolean = false;
    testParam: CommonParam;
    doAdvSearch(param: CommonParam) {
        this.getSearchTypes();
        this.testParam = param;
        this.dataLoading = true;
        param.active = false;
        this.showAdvanced(false);
        this.svc_dqoi.generic_Search(param).subscribe(
            {
                next:
                    (info: BaseMessageInfo) => {
                        if (info.saveError) {
                            console.error(info);
                            this.dataLoading = false;
                            this.globals.notifyError("Unable to complete search. Please try again", true);
                            return;
                        }
                        this.gridDataOriginal = JSON.parse(info.primaryReturn);
                        this.gridData = _.cloneDeep(this.gridDataOriginal);
                        this.dataLoading = false;
                    },
                error: (e) => {
                    console.error(e);
                    this.dataLoading = false;
                    this.globals.notifyError("Unable to complete search. Please try again", true);
                }
            });
    }
    advSearchCancel(e: any) {
        this.showAdvanced(false);
    }
    configureAdvanced() {
    }
    test() {
        let cParam: CommonParam = new CommonParam();
        cParam.userId = this.globals.userId;
        cParam.searchTarget = this.getSearchTarget(this.code);
        cParam.companyId = this.globals.companyId;
        cParam.dcParams = this.advancedDataValues;
        this.svc_srch.getCPSearchTest(cParam).subscribe();
    }
    getSearchTarget(searchType: string): any {
        switch (searchType) {
            case "Inventory":
                return SearchTarget.inventory;
            case "InventoryLocation":
                return SearchTarget.inventoryLocation;
            case "Dispatch":
                return SearchTarget.dispatch;
            case "QuoteTemplate":
                return SearchTarget.quoteTemplate;
            case "VendorCredit":
                return SearchTarget.vendorCredit;
            case "VendorReturns":
                return SearchTarget.vendorReturn;
            case "Orders":
                return SearchTarget.order;
            case "Invoices":
                return SearchTarget.invoice;
            case "Quotes":
                return SearchTarget.quote;
            case "Vehicle":
                return SearchTarget.vehicle;
            case "Suppliers":
                return SearchTarget.Supplier;
            case "AssetsTracking":
                return SearchTarget.AssetsTracking;
            case "AssetWarehouse":
                return SearchTarget.AssetWarehouse;
            case "BillingCode":
                return SearchTarget.BillingCode;
            case "Employees":
                return SearchTarget.employee;

        }
    }
    getSearchTableType(searchType: string): any {
        switch (searchType) {
            case "Inventory":
                return SearchTableType.Inventory;
            case "InventoryLocation":
                return SearchTableType.InventoryLocation;
            case "Dispatch":
                return SearchTableType.Dispatch;
            case "QuoteTemplate":
                return SearchTableType.QuoteTemplate;
            case "VendorCredit":
                return SearchTableType.VendorCredits;
            case "VendorReturns":
                return SearchTableType.VendorReturns;
            case "Orders":
                return SearchTableType.Orders;
            case "Invoices":
                return SearchTableType.Invoices;
            case "Quotes":
                return SearchTableType.Quotes;
            case "Vehicle":
                return SearchTableType.Vehicles;
            case "Suppliers":
                return SearchTableType.Supplier;
            case "AssetsTracking":
                return SearchTableType.AssetsTracking;
            case "BillingCode":
                return SearchTableType.BillingCode;
            case "Employees":
                return SearchTableType.Employees;
        }
    }
    getParam(search: string, isActive: boolean = true, isCustom: boolean = false, take: number = null): CommonParam {
        let cParam: CommonParam = new CommonParam();
        cParam.userId = this.globals.userId;
        cParam.searchTarget = this.getSearchTarget(this.code);
        cParam.companyId = this.globals.companyId;
        cParam.search = search;
        cParam.active = isActive;
        cParam.custom = isCustom;
        cParam.isWarranty = this.isWarranty === false ? this.isWarranty : null;
        cParam.includeRetired = this.includeRetired;

        cParam.take = take === null ? this.globals.search_take : take;
        if (isCustom) {
            cParam.dcParams = _.cloneDeep(this.advancedDataValues);
        }
        else {
            if (CommonFunctions.hasValue(this._initialParams)) {
                cParam.dcParams = _.cloneDeep(this._initialParams.dcParams);
            }
        }
        if (CommonFunctions.hasStringValue(this.customInputCode)) {
            cParam.addParam("CUSTOMINPUTCODE", this.customInputCode);
            cParam.addParam("CUSTOMINPUTVALUE", this.customInputValue);
        }
        if (CommonFunctions.hasStringValue(this.appCode)) {
            cParam.addParam("APPCODE", this.appCode);
        }
        if (cParam.searchTarget == SearchTarget.inventory) {
            cParam.addParam("NOTALLOWASSETPART", this.notAllowAssetPart);
        }
        return cParam;
    }
    getCBODataSource(dataItem: SearchTypeFieldBus) {
        let dataName: string = dataItem.dataName;
        if (this.advancedRefData !== undefined && this.advancedRefData !== null) {
            return this.advancedRefData[dataName];
        }
        else {
            return "";
        }
    }
    getCBODataValue(dataItem: SearchTypeFieldBus) {
        let fieldIdName: string = dataItem.fieldIdName;
        if (this.advancedDataValues !== undefined && this.advancedDataValues !== null) {
            return "advancedDataValues['" + fieldIdName + "']";
        }
        else {
            return "";
        }
    }
    public setSearchText(value: string) {
        this.searchText(value);

        setTimeout(() => {
            this.cpSearchInputPlaceholder.setValue(value);
        },
            500);

    }
    public setSearchTextPage(value: string) {
        this.searchText(value, true);
    }
    public validate(value: string) {
        this.validateMode = true;
        this.searchText(value);

        setTimeout(() => {
            this.cpSearchInputPlaceholder.setValue(value);
        },
            500);

    }
    searchText(value: string, skipvalueUpdate: boolean = false) {
        if (!CommonFunctions.hasValue(this.searchType) || !CommonFunctions.hasStringValue(value)) {
            this.dataLoading = false;
            this.gridDataOriginal = [];
            this.gridData = [];
            return;
        }
        if (!skipvalueUpdate) {
            this.searchValue = value;
        }
        this.searchValueChanged.emit(this.searchValue);
        var activeOnly = true;
        if (this.showInActive) { activeOnly = this.isActive; }
        else { activeOnly = this.activeOnly; }

        this.search(value, activeOnly, this.advancedSearchOn);
        this.searchFilter = value.replace(/\*/g, "");
    }

    private processCPSearchData(data: any) {
        this.gridDataOriginal = data;
        this.showAdvanced(false);
        if (this.returnIfSingular) {
            if (this.gridDataOriginal.length == 1) {
                this.selected.emit(this.gridDataOriginal[0]);
            }
        }
        if (this.validateMode) {
            if (this.gridDataOriginal.length == 1) {
                this.selected.emit(this.gridDataOriginal[0]);
            }
            else {
                this.validationError.emit(null);
            }
        }
        this.validateMode = false;
        this.returnIfSingular = false;
        this.gridData = _.cloneDeep(this.gridDataOriginal);
        this.dataLoading = false;
    }

    currentSearchTarget: number;
    search(search: string, isActive: boolean = true, isCustom: boolean = false, take: number = null) {
        let param: CommonParam = this.getParam(search, isActive, isCustom, take);
        this.currentSearchTarget = param.searchTarget;
        this.dataLoading = true;
        if (this.compFeatureFlagSet.featureFlagSet["new-employee-search"] && param.searchTarget === SearchTarget.employee) {
            //new for passthrough API.
            let getSearchData: any;
            switch (param.searchTarget) {
                case SearchTarget.employee: {
                    getSearchData = this.svc_srch.getEmployeeSearch(param);
                }
            }
            if (getSearchData) {
                getSearchData.subscribe(
                    {
                        next:
                            data => {
                                this.dataLoading = false;
                                this.processCPSearchData(data.resultList);
                            },
                        error: e => {
                            console.error(e);
                            this.globals.notifyError("Unable to complete search. Please try again", true);
                            this.dataLoading = false;
                        }
                    });
            }
        } else {
            // Original for 2.2
            this.svc_srch.getCPSearch(param).subscribe(
                {
                    next:
                        data => {
                            this.dataLoading = false;
                            this.processCPSearchData(JSON.parse(data));
                        },
                    error: e => {
                        console.error(e);
                        this.globals.notifyError("Unable to complete search. Please try again", true);
                        this.dataLoading = false;
                    }
                });
        }
    }
    //ITDEV-453 - Temporary solution for issue with new API returning correct formatting of properties: new way 'firstName', old way 'FirstName'.
    //This caused the data to not populate the columns because of the mismatched property names.
    //Creating a function below to modify the column coming from the dataBase to set the columnName to lower case first letter.
    //Eventualy all searchs will be the "new way" and we will need to script out the table [SearchTypeFields] and modify the values to be in the correct format. Along with other code cleanup.
    lowerCaseFieldName(field: any) {
        if (this.compFeatureFlagSet.featureFlagSet["new-employee-search"] && this.code === 'Employees') {
            return field.charAt(0).toLowerCase() + field.slice(1);
            //Make lowercase
        } else {
            return field;
        }
    }

    setGridLayout() {
        this.columns = [];
        let cols: SearchTypeFieldBus[] = [];
        let colsAdvanced: SearchTypeFieldBus[] = [];
        let colsAdvancedDate: SearchTypeFieldBus[] = [];
        for (let i = 0; i < this.searchType.fields.length; i++) {
            let field: SearchTypeFieldBus = new SearchTypeFieldBus();
            if (this.searchType.fields[i].active === false) {
                continue;
            }
            field.colOrder = this.searchType.fields[i].colOrder;
            field.fieldName = this.searchType.fields[i].fieldName;
            field.fieldType = this.searchType.fields[i].fieldType;
            field.title = this.searchType.fields[i].title;
            field.hidden = this.searchType.fields[i].hidden;
            field.headerClass = this.searchType.fields[i].headerClass;
            field.columnClass = this.searchType.fields[i].columnClass;
            field.format = this.searchType.fields[i].format;
            field.media = this.searchType.fields[i].media;
            field.width = this.searchType.fields[i].width;
            if (this.searchType.fields[i].isDataColumn) {
                cols.push(field);
            }
            else {
                if (field.fieldType === 'D') {
                    colsAdvancedDate.push(field);
                }
                else {
                    field.dataName = this.searchType.fields[i].dataName;
                    field.fieldIdName = this.searchType.fields[i].fieldIdName;
                    colsAdvanced.push(field);
                }
            }
        }
        this.columns = _.cloneDeep(cols);
        this.advancedData = _.cloneDeep(colsAdvanced);
        this.advancedDataDate = _.cloneDeep(colsAdvancedDate);
        for (let i = 0; i < colsAdvanced.length; i++) {
            let fieldIdName: string = colsAdvanced[i].fieldIdName;
            this.advancedDataValues[fieldIdName] = null;
        }
    }
    getHidden(par: SearchTypeFieldBus): Boolean {
        return par.hidden;
    }
    getWidth(par: SearchTypeFieldBus): number {
        if (par.columnClass) {
            switch (par.columnClass) {
                case "grid-col-sm":
                    return 60;
                case "grid-col-med":
                    return 120;
                case "grid-col-large":
                    return 250;
            }
        } else {
            return par.width;
        }
    }
    apply() {
        this.search(this.searchValue, this.isActive, true);
        this.advancedSearchOn = true;
    }
    clear() {
        for (var prop in this.advancedDataValues) {
            this.advancedDataValues[prop] = null;
        }
        this.advancedSearchOn = false;
        this.search(this.searchValue, this.isActive, false);
    }

    public toggleText: string = "Show";
    public show: boolean = false;

    public enabled: boolean = true;
    public duration: number = 100;
    public type: string = 'slide';
    public direction: string = 'right';

    public get animate(): any {
        if (this.enabled) {
            return {
                type: this.type,
                direction: this.direction,
                duration: this.duration
            };
        }

        return false;
    }

    public get hasDirection(): boolean {
        return this.type === 'slide' || this.type === 'expand';
    }

    public onToggle(): void {
        this.show = !this.show;
        this.toggleText = this.show ? "Hide" : "Show";
    }
    public showTooltip(e: MouseEvent): void {
        const element = e.target as HTMLElement;
        if ((element.nodeName === 'TD' || element.nodeName === 'TH')
            && element.offsetWidth < element.scrollWidth) {
            this.tooltipDir.toggle(element);
        } else {
            this.tooltipDir.hide();
        }
    }
}
